import { render } from "./FinalResult.vue?vue&type=template&id=050179c5"
import script from "./FinalResult.vue?vue&type=script&lang=ts"
export * from "./FinalResult.vue?vue&type=script&lang=ts"

import "./FinalResult.vue?vue&type=style&index=0&id=050179c5&lang=scss"
script.render = render

export default script